// TODO: Move all session storage keys here one day
export const SESSION_STORAGE_KEYS = {
  externalReferrer: 'external_referrer',
  seenUpsellEssentials: 'upsell_essentials',
  hasLogRocketBeenInitialized: 'logRocketInitialized',
  hasSeenPOTSInterstitial: 'hasSeenPOTSInterstitial',
};
